module.exports = __webpack_public_path__ + "static/algemene-voorwaarden-a6013f64f44c2335b0fe32b595d177e6.pdf";